import _extends from 'babel-runtime/helpers/extends';
// 日历
import Layout from '@/views/layout/CalendarLayout';

var layout = function layout() {
  var meta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    path: '/calendar',
    component: Layout,
    meta: _extends({
      requiresAuth: false
    }, meta)
  };
};

export default [_extends({}, layout({
  permissions: ['crm']
}), {
  children: [{
    path: 'index', // 列表
    component: function component() {
      return import('@/views/calendar/index');
    },
    meta: {
      title: '我的日历',
      icon: 'board'
    }
  }]
})];